/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import ZoneUsers from 'solis/logic/board/zone/users';


export default class
{
  constructor (account)
  {
    this.account = account;
  }


  matches (zone)
  {
    return new ZoneUsers(zone).getSectorUser() === this.account.cass.id;
  }


  equals (other)
  {
    return other !== null && other.constructor === this.constructor && this.account.equals(other.account);
  }


};
